<div *ngIf="isLoading" class="spinner-border text-primary landingspinner" style="width: 5rem; height: 5rem"
  role="status">
  <span class="sr-only">Loading...</span>
</div>
<div class="container py-5" *ngIf="!isLoading">
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a href="#" class="nav-link active title-3">Ricerca</a>
    </li>
  </ul>
  <div class="card">
    <div class="card-body">
      <form [formGroup]="formFiltro">
        <div class="group-inline pt-3">
          <div class="form-group field-16">
            <label for="codiceFiscale">Codice fiscale</label>
            <input type="text" class="form-control" id="codiceFiscale" formControlName="codiceFiscale"
              (keydown)="maxLengthInput($event, 16)">
            <div
              *ngIf="formFiltro.get('codiceFiscale')?.invalid && formFiltro.get('codiceFiscale')?.errors?.['pattern']">
              Codice fiscale non valido
            </div>
          </div>
          <div class="form-group field-20">
            <label>Nome</label>
            <div>
              <input type="text" class="form-control" id="nome" formControlName="nome">
            </div>
          </div>
          <div class="form-group field-20">
            <label>Cognome</label>
            <div>
              <input type="text" class="form-control" id="cognome" formControlName="cognome">
            </div>
          </div>
          <div class="form-group field-10">
            <label>Data di nascita</label>
            <div class="input-group">
              <input type="text" class="form-control" placeholder="yyyy-mm-dd" name="dataNascita" ngbDatepicker
                #d="ngbDatepicker" (dateSelect)="onDateSelect($event, 'dataNascita')"
                [minDate]="{year: 1900, month: 1, day: 1}"
                [maxDate]="{year: dataOdierna.getFullYear() , month: dataOdierna.getMonth() + 1 , day: dataOdierna.getDate()}"
                formControlName="dataNascita" />
              <button class="btn btn-secondary " style="align-items: center;" (click)="d.toggle()" type="button">
                <img src="../assets/icons/calendar_ko.png" class="img-responsive" style="width: 20px; height:20px">
              </button>
            </div>
          </div>
          <div class="form-group field-10">
            <label>Data di morte</label>
            <div class="input-group">
              <input type="text" class="form-control" placeholder="yyyy-mm-dd" name="dataMorte" ngbDatepicker
                #l="ngbDatepicker" [minDate]="{year: 1900, month: 1, day: 1}"
                [maxDate]="{year: dataOdierna.getFullYear() , month: dataOdierna.getMonth() + 1 , day: dataOdierna.getDate()}"
                (dateSelect)="onDateSelect($event, 'dataMorte')" formControlName="dataMorte" />
              <button class="btn btn-secondary" style="align-items: center;" (click)="l.toggle()" type="button">
                <img src="../assets/icons/calendar_ko.png" class="img-responsive" style="width: 20px; height:20px">
              </button>
            </div>
          </div>
          <div *ngIf="operatoreRegione" class="form-group field-10">
            <label>ASL</label>
            <input type="text" class="form-control" id="asl"
            formControlName="asl" [ngbTypeahead]="searchAslAbruzzo">
            <div>
              <!-- <select name="asl" id="asl" class="custom-select-300" formControlName="asl">
                option 
              </select>> -->
            </div>
            <!-- <select name="luogoDecesso" id="luogoDecesso" class="custom-select-400" (change)="showInputLuogo($event)"
              formControlName="fkLuogoDecesso" [ngClass]="{'border-red': invalidBorder('fkLuogoDecesso') == true}"
              [ngClass]="{'disabledSelect': disableSelect == true}">
              <option *ngFor="let lDecesso of dizionarioLuogoDecesso" [value]="lDecesso.codice">
                {{lDecesso.descrizione}}
              </option>
            </select> -->
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer">
      <div class="btn-toolbar">
        <div class="btn-group-left">
          <button class="btn btn-outline-secondary" (click)="cancellaFiltro()">
            Pulisci
          </button>
        </div>
        <div class="btn-group-center">

        </div>
        <div class="btn-group-right">
          <button class="btn btn-secondary" (click)="attivaFiltroECarica()">
            Cerca
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-5">
    <!--div class="card-title-text-info" style="padding-top: 5px; font-size: medium; text-align: center;">
      La tabella mostra i risultati di coloro che presentano le caratteristiche selezionate attraverso i filtri di
      ricerca
    </div-->
    <div class="card-body">
      <div class="table-responsive">
        <div class="list-table table-even">
          <table class="table table-lg table-striped">
            <thead>
              <tr>
                <th (click)="sortByAndGo('id')">ID</th>
                <th (click)="sortByAndGo('codiceFiscale')">Codice fiscale</th>
                <th (click)="sortByAndGo('nome')">Nome</th>
                <th (click)="sortByAndGo('cognome')">Cognome</th>
                <th *ngIf="operatoreRegione">ASL</th>
                <th>Età</th>
                <th>Atto di morte</th>
                <th>Dt. Inserimento</th>
                <!--th>Stato</th-->
                <!--<th>Azioni</th>-->
              </tr>
            </thead>
            <tbody>
              <ng-container>
                <tr class="tr-hover" *ngFor="let ana of paginaAnagrafica?.content"
                  (click)="goToSchedaMorteModifica(ana.id)">
                  <td class="td-hover">{{ana.id}}</td>
                  <td class="td-hover">{{ana.codiceFiscale}}</td>
                  <td class="td-hover">{{ana.nome}}</td>
                  <td class="td-hover">{{ana.cognome}}</td>
                  <td *ngIf="operatoreRegione" class="td-hover">{{ana.codiceAslOperatoreInserimento}}</td>
                  <td class="td-hover">{{ana.etaCompiuta}}</td>
                  <td class="td-hover">{{ana.datiParteBS?.attoMorteNumero}}</td>
                  <td class="td-hover">{{ana.createdOn | date: 'dd/MM/yyyy HH:mm'}}</td>
                  <!--td class="td-hover" style="font-weight: bold;">???</td-->
                  <!--                  <td class="td-hover"
                      style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">

                    <button class="btn btn-icon-solo btn-secondary" title="Modifica utente">
                      <svg class="s-icon icon-xs">
                        <use xlink:href="./assets/icons/sprite.svg#edit"></use>
                      </svg>
                    </button>
                                       
                  </td>
-->
                </tr>
              </ng-container>
            </tbody>
          </table>
          <nav style="margin-top:20px; display: flex; justify-content: space-evenly;">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginaAnagrafica?.first">
                <a class="page-link" (click)="cambiaPagina(pagina-1)" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [class.active]="paginaAnagrafica?.number==i"
                *ngFor="let pag of numberOfPages(paginaAnagrafica?.totalPages); let i = index"><a class="page-link"
                  (click)="cambiaPagina(i)">{{i+1}}</a></li>
              <li class="page-item" [class.disabled]="paginaAnagrafica?.last">
                <a class="page-link" aria-label="Next" (click)="cambiaPagina(pagina+1)">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <div class="btn-fixed fixed">
    <div class="btn-toolbar">
      <div class="container" *ngIf="modificaAbilitata">
        <div class="btn-group-left">
        </div>
        <div class="btn-group-right">
          <button (click)="creaSchedaTest()" class="btn btn-warning" *ngIf="!environment.production">Crea scheda di
            test</button>
        </div>
        <div class="btn-group-right">
          <button (click)="goToSchedaMorteNuova()" class="btn btn-secondary">Aggiungi nuova scheda</button>
        </div>
      </div>
    </div>
  </div>
</div>